/*
 *
 * Authorization API
 *
 */

export { makeRequest } from './actions';
export { NAMESPACE } from './constants';
export { default as reducer } from './reducer';



// WEBPACK FOOTER //
// ./src/services/SsoLogin/index.js